import { IPeriodConfiguration, TimeInterval, PeriodReference, IBindable } from '../../models';

export class GroupStatesConfiguration implements IPeriodConfiguration {
    mode: number;
    sortByFrequency: boolean;
    series: GroupStateConfiguration[];
    options: any = {};
    isLegendVisible: boolean = false;
    minPeriod: TimeInterval;
    maxPeriod: TimeInterval;
    alignedOn: PeriodReference;
    isEndDateIncluded: boolean = true;

    constructor() {
        this.series = [];
        this.mode = 1;
        this.alignedOn = 0;
    }
}

export interface GroupStateConfiguration extends IBindable {
    hasComment: boolean;
    hasType: boolean;
}